import { render } from "./accordionsList.vue?vue&type=template&id=27449d5a"
import script from "./accordionsList.vue?vue&type=script&lang=js"
export * from "./accordionsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__